module.exports = __webpack_public_path__ + "static/media/ic-multiple-floor.721438fe.svg";